import React, { useEffect, useRef, useState } from "react";
import CommentForm from "./CommentForm.js";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import { useLightBox } from "../../../../contexts/lightBoxContext/lightBoxContext.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import { useComments } from "../../../../contexts/commentsContext/commentsContext.js";
import GetTransformedDate from "../../../../utils/dateViewTransformer.tsx";
import { decode } from "html-entities";
import parse from "html-react-parser";

const CommentElement = ({ id, itemId, children }) => {
  const { setLightBox } = useLightBox();
  const { getAllCommentsData, deleteComment } = useComments();
  const { isMailAvailable } = useMail();
  const { isLoggedIn, getUserData } = useUser();
  const { getTextByKey } = useContent();
  const [reply, setReply] = useState(null);
  const [edit, setEdit] = useState(null);

  const commentRef = useRef();

  const dateToShow =
    getAllCommentsData()[id].Updated || getAllCommentsData()[id].Created;

  const relevantFileId = getAllCommentsData()[id].RelevantFile;
  const relevantFileData = getAllCommentsData()[id].RelevantFileModel;

  // useEffect(() => {
  //   commentRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
  // }, []);

  return (
    <div
      className={`comment-component${edit || reply ? " fullwidth" : ""}`}
      ref={commentRef}
    >
      {!itemId &&
        !getAllCommentsData()[id].Parent &&
        relevantFileId &&
        isMailAvailable() && (
          <div
            className="relevant-file clickable"
            onClick={() => {
              setLightBox(
                relevantFileData.Type,
                relevantFileId,
                relevantFileData
              );
            }}
          >
            <div className="file-image">
              <Icon
                src={relevantFileData?.ThumbSrc}
                name={!relevantFileData?.ThumbSrc ? "file" : null}
              />
            </div>
            &#x200E;{relevantFileData.Name}
          </div>
        )}
      <div className="comment-header">
        <div
          className="comment-user-avatar"
          style={{
            background: `url("${getAllCommentsData()[id].UserAvatar}"), center`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="comment-user-name">
          {getAllCommentsData()[id].UserName}
        </div>
        <div className="flex-spacer"></div>
        <div className="comment-date text-end">
          {getAllCommentsData()[id].Updated && (
            <span className="info">
              {getTextByKey("sidebar-comment-edited")}
            </span>
          )}
          <GetTransformedDate date={dateToShow} fullView={false} />
        </div>
      </div>
      <div className="comment-content">
        {edit ? (
          <CommentForm {...{ edit, itemId }} callback={() => setEdit()} />
        ) : (
          parse(decode(getAllCommentsData()[id].Content))
        )}
      </div>
      {isLoggedIn() ? (
        <div className="comment-actions">
          {!getAllCommentsData()[id].Parent && (
            <span onClick={() => setReply(getAllCommentsData()[id])}>
              <Icon name="reply" small gray />
              {getTextByKey("sidebar-comment-reply")}
            </span>
          )}
          {getUserData().UserId === getAllCommentsData()[id].UserId && (
            <>
              <span onClick={() => setEdit(getAllCommentsData()[id])}>
                <Icon name="pancil" small gray />
                {getTextByKey("sidebar-comment-edit")}
              </span>
              <span onClick={() => deleteComment(id)}>
                <Icon name="trash-solid" small gray />
                {getTextByKey("sidebar-comment-delete")}
              </span>
            </>
          )}
        </div>
      ) : null}
      {reply && (
        <CommentForm {...{ reply, itemId }} callback={() => setReply()} />
      )}
      {children}
    </div>
  );
};

export default CommentElement;
